/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetCancleRegParams } from "@/api";
import Clocker from "vux/src/components/clocker/index.vue";
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { ACTION_APPTREG_CANCLEREGINFO, ACTION_APPTREG_DELETEREGINFO } from '@/store/mutation_types';
import Cons from "Constant";
export default {
  props: {
    obj: {
      type: Object
    },
    index: {
      type: Number
    },
    type: {
      type: String
    },
    payEndTime: {
      type: String,
      "default": ''
    }
  },
  data: function data() {
    return {};
  },
  components: {
    Clocker: Clocker
  },
  created: function created() {},
  mounted: function mounted() {},
  watch: {},
  methods: _objectSpread(_objectSpread({}, mapActions([ACTION_APPTREG_CANCLEREGINFO, ACTION_APPTREG_DELETEREGINFO])), {}, {
    /*评价、查看评价-点击事件*/
    toEval: function toEval(index, type) {
      var apptordercode = null;
      var clinicName = null;
      var doctorName = null;
      var apptFlag = 0;

      if (that.vm.curPage == 0) {
        apptordercode = that.vm.regNowList[index].apptOrderCode;
        clinicName = that.vm.regNowList[index].clinicName || '';
        doctorName = that.vm.regNowList[index].doctorName || '';
        apptFlag = that.vm.regNowList[index].apptFlag || 0;
      } else {
        apptordercode = that.vm.regHisList[index].apptOrderCode;
        clinicName = that.vm.regHisList[index].clinicName || '';
        doctorName = that.vm.regHisList[index].doctorName || '';
        apptFlag = that.vm.regHisList[index].apptFlag || 0;
      }

      window.history.replaceState(that.vm.$data, "title");
      window.location.href = '../apptReg/addEvaluation.html?apptordercode=' + apptordercode + '&clinicName=' + clinicName + '&doctorName=' + doctorName + '&type=' + type + '&apptFlag=' + apptFlag;
    },
    //预约按钮 -- 点击事件
    cancleEvent: function cancleEvent(obj, index) {
      var _this = this;

      GetCancleRegParams(obj.apptOrderCode).then(function (data) {
        if (data && data.limit) {
          Public.dialog({
            content: "\u5C31\u8BCA\u524D".concat(data.hour || 24, "\u5C0F\u65F6\u5185\u65E0\u6CD5\u53D6\u6D88\u9884\u7EA6\uFF0C\u8BF7\u8054\u7CFB\u533B\u7597\u673A\u6784\u5904\u7406"),
            cancelText: '算了',
            confirmText: '拨打电话'
          }).then(function () {
            window.location.href = 'tel:' + data.phone;
          });
        } else {
          Public.dialog({
            content: '是否确认取消？'
          }).then(function () {
            _this.cancleRegInfoAjax(obj, index);
          });
        }
      });
    },
    //支付事件
    toPayEvent: function toPayEvent(obj) {
      var apptRecordId = obj.recordId;
      var childClinicId = obj.clinicId;
      var payPrice = obj.payPrice;

      if (Cons.ENV_DEBUG) {
        this.$router.push({
          name: 'PayApptPay',
          query: {
            apptRecordId: apptRecordId,
            childClinicId: childClinicId,
            payPrice: payPrice
          }
        });
      } else {
        var appId = Utils.getSessionCache(Cons.APPID);
        var clinicId = Utils.getSessionCache(Cons.CLINIC_ID);
        window.location.href = Cons.SCRM_PATH + "pay/apptPay?apptRecordId=".concat(apptRecordId, "&appId=").concat(appId, "&clinicId=").concat(clinicId, "&payPrice=").concat(payPrice, "&childClinicId=").concat(childClinicId);
      }
    },

    /**
     * 取消预约 cancleRegInfoAjax
     *
     * @param orderCode 订单号
     */
    cancleRegInfoAjax: function cancleRegInfoAjax(obj, index) {
      var that = this;
      this.ACTION_APPTREG_CANCLEREGINFO({
        obj: obj,
        index: index
      }).then(function (data) {
        if (data && data.limit) {
          Public.dialog({
            content: "\u5C31\u8BCA\u524D".concat(data.hour || 24, "\u5C0F\u65F6\u5185\u65E0\u6CD5\u53D6\u6D88\u9884\u7EA6\uFF0C\u8BF7\u8054\u7CFB\u533B\u7597\u673A\u6784\u5904\u7406"),
            cancelText: '算了',
            confirmText: '拨打电话'
          }).then(function () {
            window.location.href = 'tel:' + data.phone;
          });
        }
      });
    }
  })
};